export const settingConstants = {
    GET_REQUEST_SETTING: "GET_REQUEST_SETTING",
    GET_SUCCESS_SETTING: "GET_SUCCESS_SETTING",
    GET_FAILURE_SETTING: "GET_FAILURE_SETTING",

    CREATE_REQUEST_SETTING: "CREATE_REQUEST_SETTING",
    CREATE_SUCCESS_SETTING: "CREATE_SUCCESS_SETTING",
    CREATE_FAILURE_SETTING: "CREATE_FAILURE_SETTING",

    UPDATE_REQUEST_SETTING: "UPDATE_REQUEST_SETTING",
    UPDATE_SUCCESS_SETTING: "UPDATE_SUCCESS_SETTING",
    UPDATE_FAILURE_SETTING: "UPDATE_FAILURE_SETTING"
}